<agpr-take-over-panel
    [header]="title"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    [hideSlideOverlay]="hideSlideOverlay"
    [showFooter]="false"
    (visibleChange)="close()"
    (finishedOpen)="panelOpened()"
    [responsiveWidth]="true"
    [minPanelWidth]="minPanelWidth"
    [maxPanelWidth]="maxPanelWidth"
>
    <div class="agpr-alert-surge-sensitivity-dialog-bodyWrapper">
        <div
            class="agpr-alert-surge-sensitivity-dialog-container"
            [agprLoading]="loading"
        >
            <h5 class="agpr-alert-surge-sensitivity-dialog-container-title">
                {{'Alerts.surge.dialog.title.' + metric | localize}}
            </h5>
            @if (chart) {
                <agpr-chart [chart]="chart"></agpr-chart>
            }
        </div>
    </div>

    <!-- footer -->
    <div class="agpr-alert-surge-sensitivity-dialog-bodyFooter">
        <agpr-action-bar>
            <ng-template #left>
                <agpr-button
                    [id]="'agpr_agpr-alert-surge-sensitivity-dialog_cancel'"
                    label="Core.button.cancel"
                    [style]="buttonTypes.secondary"
                    (click)="close()"
                ></agpr-button>
            </ng-template>
        </agpr-action-bar>
    </div>
</agpr-take-over-panel>
